import { ActivityCategory, AvatarConfig } from './user';
import { REACTION_EMOJIS, ReactionEmoji, REACTION_KEYS } from './pin';

export { REACTION_EMOJIS, REACTION_KEYS };
export type { ReactionEmoji };

export interface StabeonEvent {
  id: string;
  creatorId: string;
  creatorNick: string;
  creatorAvatar?: AvatarConfig;
  lat: number;
  lng: number;
  title: string;
  description: string;
  category: ActivityCategory;
  imageData?: string;
  startsAt: number;
  endsAt: number;
  createdAt: number;
  attendeeCount: number;
  commentCount: number;
  locationName?: string;
  maxAttendees?: number; // 0 = unlimited
  recurring?: 'none' | 'daily' | 'weekly' | 'monthly';
  ticketUrl?: string; // External ticket/buy link
  price?: string; // Free or price string e.g. "$10", "Free"
  venueName?: string; // Specific venue name
  contactNote?: string; // Organizer contact note
  tags?: string; // Comma-separated tags
  waitlistCount?: number; // people on waitlist when event is full
  attendeePreview?: string; // JSON [{e,b,u}] — first 5 attendees' emoji+bgColor+userId
  coOrganizers?: string; // JSON array of approved co-organizer user IDs
  // Reactions
  reactions_fire: number;
  reactions_heart: number;
  reactions_skull: number;
  reactions_hundred: number;
  reactions_eyes: number;
}

export interface EventAttendee {
  userId: string;
  nickname: string;
  avatar?: AvatarConfig;
  rsvpAt: number;
}

export type EventStatus = 'upcoming' | 'happening' | 'ended';

export function getEventStatus(event: StabeonEvent): EventStatus {
  const now = Date.now();
  if (now < event.startsAt) return 'upcoming';
  if (now >= event.startsAt && now <= event.endsAt) return 'happening';
  return 'ended';
}

export function getEventCountdown(event: StabeonEvent): string {
  const now = Date.now();
  if (now >= event.startsAt && now <= event.endsAt) return 'Happening now';
  if (now > event.endsAt) return 'Ended';

  const diff = event.startsAt - now;
  const days = Math.floor(diff / 86400000);
  const hours = Math.floor((diff % 86400000) / 3600000);
  const mins = Math.floor((diff % 3600000) / 60000);

  if (days > 0) return `In ${days}d ${hours}h`;
  if (hours > 0) return `In ${hours}h ${mins}m`;
  return `In ${mins}m`;
}

export function getEventReactionCount(event: StabeonEvent, emoji: ReactionEmoji): number {
  const key = REACTION_KEYS[emoji];
  return (event as any)[`reactions_${key}`] || 0;
}

export function formatEventTime(ts: number): string {
  return new Date(ts).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

export function formatEventDate(ts: number): string {
  return new Date(ts).toLocaleDateString('en', { weekday: 'short', month: 'short', day: 'numeric' });
}

export function isEventExpired(event: StabeonEvent): boolean {
  return Date.now() > event.endsAt;
}

export function isSameDay(ts1: number, ts2: number): boolean {
  const d1 = new Date(ts1);
  const d2 = new Date(ts2);
  return d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate();
}
